import {GameState} from '@colonist/game-states'
import {cloneDeep} from 'lodash-es'
import {StateCreator} from 'zustand'

export interface GameStateSlice {
    gameState: GameState
    setGameState: (gameState: GameState, keysInDiff: string[]) => void
}

export interface GameStateSliceProps {
    initialGameState: GameState
}

export const createGameStateSlice = ({
    initialGameState,
}: GameStateSliceProps): StateCreator<GameStateSlice> => (set, get) => ({
    gameState: cloneDeep(initialGameState),
    setGameState: (gameState: GameState, keysInDiff: string[]) => {
        const newGameState = {...get().gameState}
        for(const key of keysInDiff) {
            newGameState[key] = {...gameState[key]}
        }
        set({gameState: newGameState})
    },
})
